import {
  TopicCategory,
  TopicCategoryFormData,
} from "../../core/topicCategory/entities/TopicCategory";
import { pb } from "../pocketbase/pocketbase";
import { RepositoryInterface } from "../interfaces/RepositoryInterface";

const collection = "topicCategories";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapRecordToTopicCategory(record: any): TopicCategory {
  return {
    id: record.id,
    name: record.name,
    rank: record.rank,
    trainingId: record.trainingId ?? record.training_id,
  };
}

export const topicCategoryRepository: RepositoryInterface<
  TopicCategory,
  TopicCategoryFormData
> = {
  async getAll(trainingId?: string): Promise<TopicCategory[]> {
    const records = await pb.collection(collection).getFullList({
      filter: trainingId ? `trainingId = "${trainingId}"` : undefined,
      sort: "rank",
    });

    return records.map(mapRecordToTopicCategory);
  },

  async getOne(id: string): Promise<TopicCategory> {
    const record = await pb.collection(collection).getOne(String(id));
    return mapRecordToTopicCategory(record);
  },

  async addUpdate(
    data: TopicCategoryFormData,
    id: number | string | null,
  ): Promise<TopicCategory> {
    const payload = {
      name: data.name,
      trainingId: data.trainingId,
    };
    let record;
    if (id) {
      record = await pb.collection(collection).update(String(id), payload);
    } else {
      record = await pb.collection(collection).create(payload);
    }

    return mapRecordToTopicCategory(record);
  },

  async delete(id: number | string): Promise<void> {
    await pb.collection(collection).delete(String(id));
  },

  async updateOrder(list: TopicCategory[]): Promise<void> {
    const updates = list.map((topicCategory, index) => ({
      id: topicCategory.id,
      rank: index + 1,
    }));

    await pb.send("/api/reorder", {
      method: "POST",
      body: {
        collection,
        data: updates,
      },
    });
  },
};
